import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { QueryClient, useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Mailbox } from 'crono-fe-common/types/mailbox';

export default function useGetEmailMailbox(withVerify: boolean) {
  const queryParams = queryString.stringify({ withVerify });

  const request: Request = {
    url: `${ENDPOINTS.email.mailbox.main}?${queryParams}`,
    config: {
      method: 'get',
    },
  };
  const requestConfig = {
    queryKey: [ENDPOINTS.email.mailbox.main, withVerify],
    queryFn: () => client(request),
    staleTime: 60 * 1000,
  };

  const { data, ...rest } = useQuery<Response<Mailbox[]>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}

export const invalidateGetEmailMailbox = (queryClient: QueryClient) => {
  queryClient.invalidateQueries([ENDPOINTS.email.mailbox.main]);
};
